"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderElementsFragment = exports.renderHTMLfragment = exports.renderHTML = void 0;
const react_1 = __importDefault(require("react"));
const el_1 = require("../node/el");
const std = __importStar(require("../law/std"));
const law_1 = require("./rules/law");
const htmlCSS_1 = __importDefault(require("./rules/htmlCSS"));
const common_1 = require("./common");
const any_1 = require("./rules/any");
const loadEL_1 = __importDefault(require("../node/el/loadEL"));
const renderHTML = (elOrJsonEL, htmlOptions) => {
    const rendered = (0, exports.renderHTMLfragment)(elOrJsonEL, htmlOptions);
    const html = /*html*/ `\
<!DOCTYPE html>
<html lang="ja">
<head>
<meta charset="UTF-8">
<style>
${htmlCSS_1.default}
</style>
</head>
<body>
${rendered}
</body>
</html>
`;
    return html;
};
exports.renderHTML = renderHTML;
const renderHTMLfragment = (elOrJsonEL, htmlOptions) => {
    const el = elOrJsonEL instanceof el_1.EL ? elOrJsonEL : (0, loadEL_1.default)(elOrJsonEL);
    const element = std.isLaw(el)
        ? react_1.default.createElement(law_1.HTMLLaw, { el: el, indent: 0, htmlOptions: htmlOptions ?? {} })
        : react_1.default.createElement(any_1.HTMLAnyELs, { els: [el], indent: 0, htmlOptions: htmlOptions ?? {} });
    const rendered = (0, common_1.renderToStaticMarkup)(element);
    return rendered;
};
exports.renderHTMLfragment = renderHTMLfragment;
const renderElementsFragment = (elements, htmlOptions) => {
    return elements.map(e => (0, exports.renderHTMLfragment)(e, htmlOptions)).join("\n");
};
exports.renderElementsFragment = renderElementsFragment;
exports.default = exports.renderHTML;
//# sourceMappingURL=html.js.map